import EditorView from "./view";
import Level from "core/level";
import Main from "./main";
export default function EditorScreen(element) {
  const view = EditorView(element);
  async function show({
    currentLevel
  }) {
    const level = Level(currentLevel);
    const main = Main(level, view);
    return await main.execute();
  }
  return Object.assign(view, {
    show
  });
}